module.exports = __webpack_public_path__ + "images/emoji/tm.5542ff72778ebce041eb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tm.png
// module id = E708
// module chunks = 14